export const RETRIEVE_INTERLOCUTOR_BENEFICIARIES_REQUEST = "RETRIEVE_INTERLOCUTOR_BENEFICIARIES_REQUEST"
export const RETRIEVE_INTERLOCUTOR_BENEFICIARIES_SUCCESS = "RETRIEVE_INTERLOCUTOR_BENEFICIARIES_SUCCESS"
export const RETRIEVE_INTERLOCUTOR_BENEFICIARIES_FAILURE = "RETRIEVE_INTERLOCUTOR_BENEFICIARIES_FAILURE"

export const RETRIEVE_BENEFICIARIES_FOR_ACCESS_REQUEST = "RETRIEVE_BENEFICIARIES_FOR_ACCESS_REQUEST"
export const RETRIEVE_BENEFICIARIES_FOR_ACCESS_SUCCESS = "RETRIEVE_BENEFICIARIES_FOR_ACCESS_SUCCESS"
export const RETRIEVE_BENEFICIARIES_FOR_ACCESS_FAILURE = "RETRIEVE_BENEFICIARIES_FOR_ACCESS_FAILURE"
